import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import Util from './common/util'
import wx from 'weixin-js-sdk'
import "swiper/swiper.min.css"
import VueLazyload from 'vue-lazyload'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueClipBoard from 'vue-clipboard2'

Vue.config.productionTip = false

Vue.use(VueClipBoard)
Vue.use(Vant);
Vue.use(VueCookie)
Vue.use(VueLazyload, {
  loading: 'https://elantran-cnd.vintro.cn/elantra_n_client_activity/images/loading.gif' // 设置懒加载时显示的图片
})

Vue.prototype.$util = Util
Vue.prototype.$wx = wx

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
